





















import Vue from 'vue';
import JerseyButtonRed from '@/components/elements/JerseyButtonRed.vue';
import JerseyButtonYellow from '@/components/elements/JerseyButtonYellow.vue';
import JerseyQuestion from '@/components/elements/JerseyQuestion.vue';
import JerseyDropdown from '@/components/elements/JerseyDropdown.vue';
import QuestionLayout from '@/views/QuestionLayout.vue';

export default Vue.extend({
  name: 'WhatsYourSignature',
  components: {
    JerseyButtonRed,
    JerseyButtonYellow,
    JerseyDropdown,
    JerseyQuestion,
    QuestionLayout,
  },
  computed: {
    question() {
      return (this as any).$store.state.isMobile
        ? (this as any).$store.state.signature.questionMobile
        : (this as any).$store.state.signature.question;
    },
    options() {
      return (this as any).$store.state.signature.options;
    },
  },
});
